import { FeatureFlagService } from './FeatureFlagService';
import { FeatureFlag } from '~/app/enums/FeatureFlag';

export class MockFeatureFlagService implements FeatureFlagService {
    public isDisabled(featureFlag: FeatureFlag): boolean {
        console.log(`Feature flag '${featureFlag}' authorized.`);

        return false;
    }

    public isEnabled(featureFlag: FeatureFlag): boolean {
        console.log(`Feature flag '${featureFlag}' authorized.`);

        return true;
    }

    public getVariant(featureFlag: FeatureFlag, defaultValue?: string): string | undefined {
        console.log(`Feature flag '${featureFlag}' variant -> default.`);

        return defaultValue;
    }

    public onFlagsResolved(callback: () => void): void {
        // No async source without PostHog: flags are "ready" immediately.
        callback();
    }
}
